<p-table [value]="itensInventario"
         [autoLayout]="true"
         [paginator]="false"
         [tableStyleClass]="'tabela-inventarios'">

  <ng-template pTemplate="header">
    <tr class="tr-inventarios">
      <th class="th-inventarios"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-inventarioDTO>
    <tr class="tr-inventarios">
      <td class="td-inventarios">{{inventarioDTO.id}} - {{inventarioDTO.nome}}</td>
    </tr>

    <!-- TABELA DE LOTES -->
    <tr class="tr-lotes">
      <td class="td-lotes">
        <p-table
          id="table-lotes"
          [value]="inventarioDTO.itensInventario"
          [autoLayout]="true"
          selectionMode="single"
          [tableStyleClass]="'tabela-lotes'">

          <ng-template pTemplate="header">
            <tr class="tr-lotes">
              <th class="th-lotes"></th>
              <th class="th-lotes">Id</th>
              <th class="th-lotes">Lote</th>
              <th class="th-lotes">Vencimento</th>
              <th class="th-lotes">Quantidade</th>
              <th class="th-lotes">Mover</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-itemInventario let-rowIndex="rowIndex">
            <tr name='tr-lotes'
                class="tr-lotes"
                [pSelectableRowIndex]="rowIndex"
                [pSelectableRowDblClick]="lote">

              <td class="td-lotes">
                <!-- checkbox_lote_IdInventario_IdLote -->
                <input
                  type="checkbox"
                  [id]="'checkbox_lote_' + inventarioDTO.id + '_' + itemInventario.lote.id"
                  name="checkboxLote"
                  value="{{montaValorDaLinha(inventarioDTO, itemInventario) | json}}"
                  (change)="atualizarValorAMover(inventarioDTO.id, itemInventario.lote.id)">

                <input
                  type="hidden"
                  [id]="'hidden_quantidade_' + inventarioDTO.id + '_' + itemInventario.lote.id"
                  value="{{itemInventario.quantidade}}">
              </td>
              <td class="td-lotes" (click)="clickCheckbox(inventarioDTO.id, itemInventario.lote.id)">{{itemInventario.lote.id}}</td>
              <td class="td-lotes" (click)="clickCheckbox(inventarioDTO.id, itemInventario.lote.id)">{{itemInventario.lote.descricao}}</td>
              <td class="td-lotes" (click)="clickCheckbox(inventarioDTO.id, itemInventario.lote.id)">{{itemInventario.lote.dataVencimento | date :'dd/MM/yyyy'}}</td>
              <td class="td-lotes" (click)="clickCheckbox(inventarioDTO.id, itemInventario.lote.id)">{{itemInventario.quantidade}}</td>
              <td class="td-lotes">

                <!-- input_mover_IdInventario_IdLote -->
                <input
                  type="number"
                  min="0"
                  [id]="'input_mover_' + inventarioDTO.id + '_' + itemInventario.lote.id"
                  name="input_mover"
                  class="input-mover"
                  (change)="atualizarCheckboxPeloValorAMover($event); getTotalAMover($event);"
                  (keypress)="getTotalAMover($event)">
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr class="tr-lotes">
              <td colspan="4" class="td-lotes"></td>
            </tr>
          </ng-template>
        </p-table>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <tr class="tr-lotes">
      <td class="td-lotes">
        <span>Nenhum lote encontrado para atender esta demanda.</span>
      </td>
    </tr>
  </ng-template>
</p-table>
